// import React, { useEffect, useState } from 'react';
// import { useHistory, useLocation } from 'react-router-dom';
// import { Box, Typography, Grid, Button, Paper, TextField, Divider } from '@mui/material';
// import TollIcon from '@mui/icons-material/Toll';
// import VerifiedIcon from '@mui/icons-material/Verified';
// import ChevronLeft from '@mui/icons-material/ChevronLeft';
// import useCatalogOrder from './useCatalogOrder';
// import MapIcon from '@mui/icons-material/Map';

// const CheckoutPage = () => {
//   const history = useHistory();
//   const location = useLocation();
//   const { 
//     orderId, 
//     processingDetails, 
//     selectedImages, 
//     drawnCoordinates, 
//     dateRange,
//     orderType,
//     taskingData // Default to archival, but can be overridden by location state
//   } = location.state || {};

//   // console.log(taskingData)
  
//   const [orderData, setOrderData] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [orderName, setOrderName] = useState("");
//   const taskDetails = taskingData || {}; 
//   // console.log(taskDetails)
  
//   // Calculate estimated delivery date based on order type
//   const [estimatedDeliveryDate, setEstimatedDeliveryDate] = useState(null);

//   const { currentOrderId, setCurrentOrderId, getOrderDetails, saveDraftOrder } = useCatalogOrder();

//   useEffect(() => {
//     if (orderId) {
//       setCurrentOrderId(orderId);
//     }
//   }, [orderId]);

//   useEffect(() => {
//     // Calculate the estimated delivery date
//     const calculateDeliveryDate = () => {
//       const now = new Date();
//       const deliveryDate = new Date(now);
      
//       if (orderType === 'tasking') {
//         // For tasking, add 1-3 days (using 2 days as average)
//         deliveryDate.setDate(now.getDate() + 18);
//       } else {
//         // For archival, add 10 minutes
//         deliveryDate.setDate(now.getDate());
//       }
      
//       setEstimatedDeliveryDate(deliveryDate);
//     };
    
//     calculateDeliveryDate();
//   }, [orderType]);

//   useEffect(() => {
//     if (!orderId) {
//       console.error('No order ID provided');
//       history.replace('/explore');
//       return;
//     }

//     const fetchOrderDetails = async () => {
//       try {
//         const details = await getOrderDetails(orderId);
//         setOrderData(details);
//       } catch (error) {
//         console.error('Error fetching order details:', error);
//         history.replace('/explore');
//         alert('Error loading order details. Please try again.');
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchOrderDetails();
//   }, [orderId, history]);

//   const calculateCosts = () => {
//     if (!orderData?.selected_images || !orderData?.aoi_coordinates) return null;

//     const imageryUnitCost = 12;
//     const processingUnitCost = 5;
//     const area = 150;

//     const imageryCost = imageryUnitCost * area;
//     const processingCost = processingUnitCost * area;

//     return {
//       imageryUnitCost,
//       processingUnitCost,
//       area,
//       imageryCost,
//       processingCost,
//       totalCost: imageryCost + processingCost
//     };
//   };

//   const handleConfirmOrder = async () => {
//     try {
//       const costs = calculateCosts();
      
//       // Properly structure the data being sent
//       const updatedOrderData = {
//         status: 'Requested',
//         order_type: orderType,
//         project_name: orderName,
//         estimated_delivery_date: estimatedDeliveryDate.toISOString(), // Add the datetime to the order data
//         processing_details: {
//           level: processingDetails.level,
//           radiometric_processing: processingDetails.radiometric_processing,
//           geometric_processing: processingDetails.geometric_processing,
//           delivery_details: processingDetails.delivery_details
//         },
//         selected_images: orderType === 'archival' ? selectedImages : [{"satellite": taskDetails.constellationName,
//                                                                       "cloud_cover": taskDetails.cloudCover, 
//                                                                       "resolution":taskDetails.resolution, 
//                                                                       "off_nadir_angle": taskDetails.offNadirAngle, 
//                                                                       "coverage_percentage": taskDetails.aoiCoverage,
//                                                                       "area":taskDetails.aoiArea,
//                                                                       "strip_coordinates":taskDetails.coordinates}],
//         aoi_coordinates: drawnCoordinates || [],
//         cost_details: {
//           imagery_cost_per_unit: costs?.imageryUnitCost ?? 0,
//           processing_cost_per_unit: costs?.processingUnitCost ?? 0,
//           area_sqkm: costs?.area ?? 0,
//           total_cost: costs?.totalCost ?? 0
//         }
//       };
  
//       console.log('Sending order data:', updatedOrderData); // Debug log
      
//       await saveDraftOrder(updatedOrderData, orderId);
//       history.push('/orders');
//     } catch (error) {
//       console.error('Error confirming order:', error);
//       alert('Error confirming order: ' + (error.message || 'Unknown error'));
//     }
//   };

//   if (isLoading) {
//     return (
//       <Box sx={{ 
//         display: 'flex', 
//         justifyContent: 'center', 
//         alignItems: 'center', 
//         height: '100vh' 
//       }}>
//         <Typography>Loading...</Typography>
//       </Box>
//     );
//   }

//   const costs = calculateCosts();

//   // Function to format the delivery date for display
//   const formatDeliveryDate = (date) => {
//     if (!date) return '';
    
//     return date.toLocaleString('en-IN', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',

//     });
//   };

//   // Function to determine which table to render based on order type
//   const renderDataTable = () => {
//     if (orderType === 'tasking') {
//       return (
//         <Box key="tasking-products" sx={{ mb: 4 }}>
//         <Box sx={{ 
//           width: '100%',
//           display: 'flex', 
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           mb: 2
//         }}>
//           <Box sx={{ 
//             display: 'flex', 
//             alignItems: 'center',
//             gap: 1 
//           }}>
//             <Typography sx={{ 
//               fontSize: '16px',
//               fontWeight: 500,
//               color: '#333'
//             }}>
//               {`${selectedImages?.length || 1} tasking request${selectedImages?.length > 1 ? 's' : ''} in the cart`}
//             </Typography>
//             <Button 
//               sx={{ 
//                 textTransform: 'none',
//                 fontSize: '14px',
//                 color: '#4287f5',
//                 fontWeight: 400
//               }}
//             >
//               Tasking Information
//             </Button>
//           </Box>
//         </Box>
    
//         {/* Table Header */}
//         <Box sx={{
//           display: 'grid',
//           gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
//           backgroundColor: '#f5f5f5',
//           py: 1.5,
//           borderRadius: '4px 4px 0 0',
//           borderBottom: '1px solid #e0e0e0'
//         }}>
//           {['CONSTELLATION', 'RESOLUTION (m)', 'CLOUD COVER %', 'OFF NADIR ANGLE (DEG)', 
//             'AOI AREA (sqkm)', 'AOI COVERAGE %', 'ESTIMATED TIME TO CAPTURE'].map((header) => (
//             <Typography key={header} sx={{ 
//               fontSize: '12px', 
//               fontWeight: 500, 
//               color: '#555', 
//               px: 1, 
//               textAlign: 'center'
//             }}>
//               {header}
//             </Typography>
//           ))}
//         </Box>
    
//         {/* Single Table Row */}
//         <Box 
//           sx={{
//             display: 'grid',
//             gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
//             py: 1.5,
//             borderBottom: '1px solid #e0e0e0',
//             alignItems: 'center',
//             '& > *': {
//               px: 1,
//               textAlign: 'center',
//               overflow: 'hidden',
//               textOverflow: 'ellipsis'
//             }
//           }}
//         >
//           <Typography sx={{ fontSize: '14px', color: '#333' }}>
//             {taskDetails.constellationName || 'N/A'}
//           </Typography>
//           <Typography sx={{ fontSize: '14px', color: '#333' }}>
//             {taskDetails.resolution || 'N/A'}
//           </Typography>
//           <Typography sx={{ fontSize: '14px', color: '#333' }}>
//             {taskDetails.cloudCover || 'N/A'}
//           </Typography>
//           <Typography sx={{ fontSize: '14px', color: '#333' }}>
//             {taskDetails.offNadirAngle }
//           </Typography>
//           <Typography sx={{ fontSize: '14px', color: '#333' }}>
//             {parseFloat(taskDetails.aoiArea).toFixed(0) || '0'}
//           </Typography>
//           <Typography sx={{ fontSize: '14px', color: '#333' }}>
//             {}
//           </Typography>
//           <Typography sx={{ fontSize: '14px', color: '#333' }}>
//             {taskDetails.estimatedTimeToCapture || 'N/A'}
//           </Typography>
//         </Box>
//       </Box>
//     );
//     } else {
//       // Original catalog products table
//       console.log(selectedImages)
      
//       const groupImagesByConstellation = (selectedImages) => {
//         return selectedImages.reduce((acc, image) => {
//           const constellation = image.satellite || 'Unknown';
//           if (!acc[constellation]) {
//             acc[constellation] = [];
//           }
//           acc[constellation].push(image);
//           return acc;
//         }, {});
//       };

//       return Object.entries(groupImagesByConstellation(selectedImages || [])).map(([constellation, images]) => (
//         <Box key={constellation} sx={{ mb: 4 }}>
//           <Box sx={{ 
//             width: '100%',
//             display: 'flex', 
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             mb: 2
//           }}>
//             <Box sx={{ 
//               display: 'flex', 
//               alignItems: 'center',
//               gap: 1 
//             }}>
//               <Typography sx={{ 
//                 fontSize: '16px',
//                 fontWeight: 500,
//                 color: '#333'
//               }}>
//                 {`${images.length} data product${images.length > 1 ? 's' : ''} in the cart for ${constellation}`}
//               </Typography>
//               <Button 
//                 sx={{ 
//                   textTransform: 'none',
//                   fontSize: '14px',
//                   color: '#4287f5',
//                   fontWeight: 400
//                 }}
//               >
//                 Processing Information
//               </Button>
//             </Box>
//           </Box>

//           {/* Table Header */}
//           <Box sx={{
//             display: 'grid',
//             gridTemplateColumns: 'repeat(9, minmax(0, 1fr))',
//             backgroundColor: '#f5f5f5',
//             py: 1.5,
//             borderRadius: '4px 4px 0 0',
//             borderBottom: '1px solid #e0e0e0'
//           }}>
//             {['DATA PRODUCT', 'CONSTELLATION', 'DATE OF CAPTURE', 'CLOUD COVER %', 'RESOLUTION (m)', 
//               'OFF NADIR ANGLE (DEG)', 'AOI COVERAGE %', 'AREA (km²)', 'ACTION'].map((header) => (
//               <Typography key={header} sx={{ 
//                 fontSize: '12px', 
//                 fontWeight: 500, 
//                 color: '#555', 
//                 px: 1, 
//                 textAlign: 'center',
//                 overflow: 'hidden',
//                 textOverflow: 'ellipsis'
//               }}>
//                 {header}
//               </Typography>
//             ))}
//           </Box>

//           {/* Table Rows */}
//           {images.map((image) => (
//             <Box 
//               key={image.id}
//               sx={{
//                 display: 'grid',
//                 gridTemplateColumns: 'repeat(9, minmax(0, 1fr))',
//                 py: 1.5,
//                 borderBottom: '1px solid #e0e0e0',
//                 alignItems: 'center',
//                 '& > *': {
//                   px: 1,
//                   textAlign: 'center',
//                   overflow: 'hidden',
//                   textOverflow: 'ellipsis'
//                 }
//               }}
//             >
//               <Box sx={{ display: 'flex', justifyContent: 'center' }}>
//                 <img 
//                   src={image.previewUrl || "/api/placeholder/80/60"}
//                   alt={`${constellation} image`}
//                   style={{ 
//                     width: '60px', 
//                     height: '60px',
//                     objectFit: 'cover',
//                     borderRadius: '4px'
//                   }}
//                 />
//               </Box>
//               <Typography sx={{ fontSize: '14px', color: '#333' }}>{constellation}</Typography>
//               <Typography sx={{ fontSize: '14px', color: '#333' }}>{image.date}</Typography>
//               <Typography sx={{ fontSize: '14px', color: '#333' }}>{image.cloud_cover} %</Typography>
//               <Typography sx={{ fontSize: '14px', color: '#333' }}>{image.resolution}</Typography>
//               <Typography sx={{ fontSize: '14px', color: '#333' }}>{image.off_nadir_angle} °</Typography>
//               <Typography sx={{ fontSize: '14px', color: '#333' }}>{`${parseFloat(image.coveragePercentage)?.toFixed(2) || 0}`} %</Typography>
//               <Typography sx={{ fontSize: '14px', color: '#333' }}></Typography>
//               <Box>
//                 <Button 
//                   sx={{ 
//                     textTransform: 'none',
//                     fontSize: '14px',
//                     color: '#4287f5',
//                     p: 0,
//                     minWidth: 'auto',
//                     mr: 1
//                   }}
//                 >
//                   View
//                 </Button>
//                 |
//                 <Button 
//                   sx={{ 
//                     textTransform: 'none',
//                     fontSize: '14px',
//                     color: '#4287f5',
//                     p: 0,
//                     minWidth: 'auto',
//                     ml: 1
//                   }}
//                 >
//                   Remove
//                 </Button>
//               </Box>
//             </Box>
//           ))}
//         </Box>
//       ));
//     }
//   };

//   return (
//     <Box sx={{ 
//       position: 'fixed',
//       top: 48,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       overflow: 'auto', 
//       px: 2, 
//     }}>
//       {/* Combined Header: Back Button, Status Bar and Save Draft */}
//       <Box sx={{ 
//         display: 'flex', 
//         justifyContent: 'flex-start', 
//         alignItems: 'center',
//         bgcolor: 'white',
//         borderRadius: '8px',
//         px: 2,
//         gap: 2,
//         mt: 1
//       }}>
//         <Button
//           startIcon={<ChevronLeft />}
//           sx={{
//             color: '#4287f5',
//             textTransform: 'none',
//             fontSize: '14px',
//             fontWeight: 500,
//             minWidth: 'auto',
//             whiteSpace: 'nowrap',
//             '&:hover': {
//               bgcolor: 'transparent',
//               opacity: 0.8
//             }
//           }}
//           onClick={() => history.goBack()}
//         >
//           Edit Order
//         </Button>
//         <Button 
//           endIcon={<MapIcon />}
//           sx={{
//             color: '#4287f5',
//             textTransform: 'none',
//             fontSize: '14px',
//             fontWeight: 500,
//             minWidth: 'auto',
//             whiteSpace: 'nowrap',
//             '&:hover': {
//               bgcolor: 'transparent',
//               opacity: 0.8
//             },
//             ml: 100
//           }}
//         >
//           View selected region
//         </Button>
//       </Box>

//       {/* Main Content and Request Details */}
//       <Box sx={{ 
//         display: 'flex',
//         gap: 0,
//         mt: 0, 
//         position: 'relative',
//         mt: -1.5
//       }}>
//         {/* Left Side - Data Tables */}
//         <Box sx={{ 
//           flex: 1,
//           width: '80%',
//           bgcolor: 'transparent',
//           borderRadius: '8px',
//           p: 1,
//           overflow: 'auto'
//         }}>
//           {renderDataTable()}
//         </Box>

//         {/* Right Side - Request Details */}
//         <Box sx={{ 
//           flex: '0 0 20%', 
//           display: 'flex',
//           flexDirection: 'column',
//           gap: 3,
//           backgroundColor: '#f2f0f0',
//           overflow: 'auto',
//           px: 2,
//           py: 2,
//           pb: 2,
//           mt: -3
//         }}>
//           <Box sx={{ 
//             display: 'flex', 
//             justifyContent: 'space-between', 
//             alignItems: 'center',
//             mb: 2
//           }}>
//             <Typography sx={{ 
//               fontSize: '18px',
//               fontWeight: 500,
//               color: '#000'
//             }}>
//               Order Details
//             </Typography>
//             <Button
//               variant="outlined"
//               sx={{
//                 color: '#4287f5',
//                 borderColor: '#4287f5',
//                 textTransform: 'none',
//                 fontSize: '14px',
//                 fontWeight: 500,
//                 whiteSpace: 'nowrap',
//                 '&:hover': {
//                   borderColor: '#3276e3',
//                   bgcolor: 'rgba(66, 135, 245, 0.04)'
//                 }
//               }}
//             >
//               Save Draft
//             </Button>
//           </Box>

//           {/* Rest of the Request Details content remains the same */}
//           <Box>
//             {/* Order Name */}
//             <Box sx={{ mb: 2 }}>
//               <Typography sx={{ 
//                 color: '#555',
//                 fontSize: '14px',
//                 mb: 1
//               }}>
//                 Order Name
//               </Typography>
//               <TextField
//                 fullWidth
//                 value={orderName}
//                 onChange={(e) => setOrderName(e.target.value)}
//                 placeholder="Enter order name"
//                 variant="outlined"
//                 sx={{
//                   mb: 0.5,
//                   '& .MuiOutlinedInput-root': {
//                     bgcolor: 'white'
//                   }
//                 }}
//               />
//               <Box>
//                 <Button 
//                   component="a" 
//                   sx={{ 
//                     p: 0,
//                     color: '#4287f5',
//                     textTransform: 'none',
//                     fontSize: '14px',
//                     minWidth: 'auto',
//                     '&:hover': {
//                       bgcolor: 'transparent',
//                       textDecoration: 'underline'
//                     }
//                   }}
//                 >
//                   View project details
//                 </Button>
//               </Box>
//             </Box>

//             {/* Order ID */}
//             <Box sx={{ mb: 2 }}>
//               <Typography sx={{ color: '#555', fontSize: '14px', mb: 1 }}>
//                 Order ID
//               </Typography>
//               <TextField
//                 fullWidth
//                 value={orderId}
//                 disabled
//                 variant="outlined"
//                 sx={{
//                   '& .MuiOutlinedInput-root': {
//                     bgcolor: '#e6e6e6'
//                   }
//                 }}
//               />
//             </Box>

//             {/* Estimated Delivery Date */}
//             <Box sx={{ mb: 2 }}>
//               <Typography sx={{ 
//                 color: '#555',
//                 fontSize: '14px',
//                 mb: 1
//               }}>
//                 Estimated Delivery Date
//               </Typography>
//               <TextField
//                 fullWidth
//                 value={formatDeliveryDate(estimatedDeliveryDate)}
//                 disabled
//                 variant="outlined"
//                 sx={{
//                   '& .MuiOutlinedInput-root': {
//                     bgcolor: '#e6e6e6'
//                   }
//                 }}
//               />
//             </Box>
//             {Object.keys(taskDetails).length < 0 && (
//             <TextField
//                 fullWidth
//                 value={formatDeliveryDate(estimatedDeliveryDate)}
                
//                 disabled
//                 variant="outlined"
//                 sx={{
//                   '& .MuiOutlinedInput-root': {
//                     bgcolor: '#e6e6e6'
//                   }
//                 }}
//               />
//             )}
            
              

//             {/* Order Description */}
//             <Box sx={{ mb: 2 }}>
//               <Typography sx={{ 
//                 color: '#555',
//                 fontSize: '14px',
//                 mb: 1
//               }}>
//                 Order Description
//               </Typography>
//               <TextField
//                 fullWidth
//                 placeholder="Type here....."
//                 multiline
//                 rows={8}
//                 variant="outlined"
//                 sx={{
//                   '& .MuiOutlinedInput-root': {
//                     bgcolor: 'white'
//                   }
//                 }}
//               />
//             </Box>
//           </Box>

//           {/* Summary Panel */}
//           <Box sx={{
//             bgcolor: '#f9f9f9',
//             borderRadius: '8px',
//             p: 3
//           }}>
//             <Typography sx={{ 
//               fontSize: '18px',
//               fontWeight: 500,
//               color: '#000',
//               mb: 3
//             }}>
//               Summary
//             </Typography>

//             <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               mb: 2
//             }}>
//               <Typography sx={{ fontSize: '14px', color: '#333' }}>Imagery per unit cost</Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography sx={{ fontSize: '14px', color: '#333', mr: 0.5 }}></Typography>
//                 <TollIcon sx={{ fontSize: 16, color: '#333' }} />
//               </Box>
              
//             </Box>
//             {Object.keys(taskDetails).length > 0 && (
//   <Box sx={{ 
//     display: 'flex', 
//     justifyContent: 'space-between', 
//     alignItems: 'center',
//     mb: 2
//   }}>
//     <Typography sx={{ fontSize: '14px', color: '#333' }}>Tasking per unit cost</Typography>
//     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//       <Typography sx={{ fontSize: '14px', color: '#333', mr: 0.5 }}>10</Typography>
//       <TollIcon sx={{ fontSize: 16, color: '#333' }} />
//     </Box>
//   </Box>
// )}

// {Object.keys(taskDetails).length == 0 && (
// <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               mb: 2
//             }}>
//               <Typography sx={{ fontSize: '14px', color: '#333' }}>Area</Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography sx={{ fontSize: '14px', color: '#333', mr: 0.5 }}></Typography>
//                 {/* <TollIcon sx={{ fontSize: 16, color: '#333' }} /> */}
//               </Box>
//             </Box>
// )}
//             {Object.keys(taskDetails).length > 0 && (
// <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               mb: 2
//             }}>
//               <Typography sx={{ fontSize: '14px', color: '#333' }}>Area</Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography sx={{ fontSize: '14px', color: '#333', mr: 0.5 }}>{parseFloat(taskDetails.aoiArea).toFixed(0)} sqkm</Typography>
//                 {/* <TollIcon sx={{ fontSize: 16, color: '#333' }} /> */}
//               </Box>
//             </Box>
//             )}

// {Object.keys(taskDetails).length > 0 && (

//             <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               mb: 2
//             }}>
// <Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#4287f5' }}>Subtotal</Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography sx={{ fontWeight: 600,fontSize: '14px', color: '#4287f5', mr: 0.5 }}></Typography>
//                 <TollIcon sx={{ fontWeight: 600,fontSize: 16, color: '#4287f5' }} />
//               </Box>
//             </Box>

//           )}
// {Object.keys(taskDetails).length == 0 && (
// <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               mb: 2
//             }}>
//               <Typography sx={{ fontWeight: 600,fontWeight: 500, fontSize: '14px', color: '#4287f5' }}>Subtotal</Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography sx={{ fontWeight: 600,fontSize: '14px', color: '#4287f5', mr: 0.5 }}></Typography>
//                 <TollIcon sx={{ fontWeight: 600,fontSize: 16, color: '#4287f5' }} />
//               </Box>
//             </Box>
// )}
//             <Divider sx={{ my: 2 }} />
//             {Object.keys(taskDetails).length == 0 && (
//             <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               mb: 2
//             }}>
//               <Typography sx={{ fontSize: '14px', color: '#333' }}>Processing Cost</Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography sx={{ fontSize: '14px', color: '#333', mr: 0.5 }}></Typography>
//                 <TollIcon sx={{ fontSize: 16, color: '#333' }} />
//               </Box>
//             </Box>)}
//             {Object.keys(taskDetails).length > 0 && (
//             <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               mb: 2
//             }}>
//               <Typography sx={{ fontSize: '14px', color: '#333' }}>Processing Cost</Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography sx={{ fontSize: '14px', color: '#333', mr: 0.5 }}>5</Typography>
//                 <TollIcon sx={{ fontSize: 16, color: '#333' }} />
//               </Box>
//             </Box>
//             )}
//             {Object.keys(taskDetails).length > 0 && (            
//             <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               mb: 2
//             }}>
//               <Typography sx={{ fontSize: '14px', color: '#333' }}>Area</Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography sx={{ fontSize: '14px', color: '#333', mr: 0.5 }}>{parseFloat(taskDetails.aoiArea).toFixed(0)} sqkm</Typography>
//                 {/* <TollIcon sx={{ fontSize: 16, color: '#333' }} /> */}
//               </Box>
//             </Box>
//             )}

// {Object.keys(taskDetails).length == 0 && (
// <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               mb: 2
//             }}>
//               <Typography sx={{ fontSize: '14px', color: '#333' }}>Area</Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography sx={{ fontSize: '14px', color: '#333', mr: 0.5 }}></Typography>
//                 {/* <TollIcon sx={{ fontSize: 16, color: '#333' }} /> */}
//               </Box>
//             </Box>
// )}
// {Object.keys(taskDetails).length == 0 && (
//             <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               mb: 2
//             }}>
//               <Typography sx={{ fontWeight: 600,fontSize: '14px', color: '#4287f5' }}>Subtotal</Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography sx={{fontWeight: 600, fontSize: '14px', color: '#4287f5', mr: 0.5 }}></Typography>
//                 <TollIcon sx={{ fontWeight: 600,fontSize: 16, color: '#4287f5' }} />
//               </Box>
//             </Box>
//              )}
// {Object.keys(taskDetails).length > 0 && (
// <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               mb: 2
//             }}>
//               <Typography sx={{fontWeight: 600, fontSize: '14px', color: '#4287f5' }}>Subtotal</Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography sx={{ fontWeight: 600,fontSize: '14px', color: '#4287f5', mr: 0.5 }}></Typography>
//                 <TollIcon sx={{fontWeight: 600, fontSize: 16, color: '#4287f5' }} />
//               </Box>
//             </Box>
//              )}
//             <Divider sx={{ my: 2 }} />
            
         






//             {Object.keys(taskDetails).length > 0 && (
//             <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               mb: 2
//             }}>
//               <Typography sx={{ fontSize: '15px', fontWeight: 600, color: '#4287f5' }}>Total</Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography sx={{ fontWeight: 600,fontSize: '15px', color: '#4287f5', mr: 0.5 }}></Typography>
//                 <TollIcon sx={{ fontWeight: 600,fontSize: 16, color: '#4287f5' }} />
//               </Box>
//             </Box>)}
//             {Object.keys(taskDetails).length == 0 && (
//             <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               mb: 2
//             }}>
//               <Typography sx={{ fontSize: '15px', fontWeight: 600, color: '#4287f5' }}>Total</Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Typography sx={{ fontSize: '15px', fontWeight: 600, color: '#4287f5', mr: 0.5 }}></Typography>
//                 <TollIcon sx={{ fontWeight: 600, fontSize: 16, color: '#4287f5' }} />
//               </Box>
//             </Box>)}
//             <Button 
//               fullWidth
//               variant="contained" 
//               sx={{ 
//                 bgcolor: '#4287f5',
//                 textTransform: 'none',
//                 fontSize: '16px',
//                 fontWeight: 500,
//                 py: 1.5,
//                 mt: 2,
//                 '&:hover': {
//                   bgcolor: '#3276e3'
//                 }
//               }}
//               onClick={handleConfirmOrder}
//             >
//               Confirm Order
//             </Button>
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default CheckoutPage;

import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Box, Typography, Grid, Button, Paper, TextField, Divider } from '@mui/material';
import TollIcon from '@mui/icons-material/Toll';
import VerifiedIcon from '@mui/icons-material/Verified';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import useCatalogOrder from './useCatalogOrder';
import MapIcon from '@mui/icons-material/Map';
import * as turf from '@turf/turf';
import axios from 'axios';
import { USER_URLS } from '../config/urls';

const CheckoutPage = () => {
  const history = useHistory();
  const location = useLocation();
  const { 
    orderId, 
    processingDetails, 
    selectedImages, 
    drawnCoordinates, 
    dateRange,
    orderType,
    taskingData // Default to archival, but can be overridden by location state
  } = location.state || {};
  
  const [orderData, setOrderData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [orderName, setOrderName] = useState("");
  const [userRole, setUserRole] = useState('');
  const taskDetails = taskingData || {}; 
  
  // Calculate estimated delivery date based on order type
  const [estimatedDeliveryDate, setEstimatedDeliveryDate] = useState(null);

  // New state for price information
  const [priceInfo, setPriceInfo] = useState({
    isLoading: true,
    data: null,
    error: null
  });

  const { currentOrderId, setCurrentOrderId, getOrderDetails, saveDraftOrder } = useCatalogOrder();

  // Fetch user role on component mount
  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(USER_URLS.getMe, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setUserRole(response.data.role || '');
      } catch (error) {
        console.error('Error fetching user role:', error);
      }
    };
    
    fetchUserRole();
  }, []);

  useEffect(() => {
    if (orderId) {
      setCurrentOrderId(orderId);
    }
  }, [orderId]);

  useEffect(() => {
    // Calculate the estimated delivery date
    const calculateDeliveryDate = () => {
      const now = new Date();
      const deliveryDate = new Date(now);
      
      if (orderType === 'tasking') {
        // For tasking, add 1-3 days (using 2 days as average)
        deliveryDate.setDate(now.getDate() + 18);
      } else {
        // For archival, add 10 minutes
        deliveryDate.setDate(now.getDate());
      }
      
      setEstimatedDeliveryDate(deliveryDate);
    };
    
    calculateDeliveryDate();
  }, [orderType]);

  useEffect(() => {
    if (!orderId) {
      console.error('No order ID provided');
      history.replace('/explore');
      return;
    }

    const fetchOrderDetails = async () => {
      try {
        const details = await getOrderDetails(orderId);
        setOrderData(details);
      } catch (error) {
        console.error('Error fetching order details:', error);
        history.replace('/explore');
        alert('Error loading order details. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchOrderDetails();
  }, [orderId, history]);

  // New effect to fetch pricing information
  useEffect(() => {
    const fetchPricing = async () => {
      if (!drawnCoordinates || !selectedImages || selectedImages.length === 0) {
        return;
      }

      try {
        setPriceInfo(prev => ({ ...prev, isLoading: true }));

        // Get product ID from first selected image (assuming all are same product)
        const productId = selectedImages[0].product_id || selectedImages[0].satellite || 'Sentinel-2';
        
        // Get processing level from processingDetails
        const processingLevel = processingDetails?.level || 'L1C';

        // const token = localStorage.getItem('token');
        // const response = await fetch('http://127.0.0.1:8000/api/calculate-price', {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //     'Authorization': `Bearer ${token}`
        //   },
        //   body: JSON.stringify({
        //     product_id: productId,
        //     processing_level: processingLevel,
        //     aoi_coordinates: drawnCoordinates
        //   })
        // });

        // if (!response.ok) {
        //   throw new Error(`API Error: ${response.status}`);
        // }

        // const priceData = await response.json();
        // const computedCosts = {
        //   ...priceData,
        //   imagery_cost: priceData.imagery_cost_per_unit * priceData.area_sqkm,
        //   processing_cost: priceData.processing_cost_per_unit * priceData.area_sqkm,
        //   total_cost:
        //     (priceData.imagery_cost_per_unit + priceData.processing_cost_per_unit) * priceData.area_sqkm
        // };
        
        // setPriceInfo({
        //   isLoading: false,
        //   data: computedCosts,
        //   error: null
        // });
        let calculatedArea = 0.0;
        const polygonCoords = drawnCoordinates.map(point => [
          point.lng !== undefined ? point.lng : point.longitude,
          point.lat !== undefined ? point.lat : point.latitude
        ]);
        
        // Close the polygon if it's not already closed
        if (polygonCoords[0][0] !== polygonCoords[polygonCoords.length-1][0] || 
            polygonCoords[0][1] !== polygonCoords[polygonCoords.length-1][1]) {
          polygonCoords.push(polygonCoords[0]);
        }
        
        // Calculate area using the Shoelace formula (Gauss's area formula)
        let area = 0;
        for (let i = 0; i < polygonCoords.length - 1; i++) {
          area += polygonCoords[i][0] * polygonCoords[i+1][1];
          area -= polygonCoords[i][1] * polygonCoords[i+1][0];
        }
        area = Math.abs(area) / 2;
        
        // Convert to square kilometers using the same approximation as the Python code
        // Area in degrees * 111km/degree * 111km/degree
        const areaSqKm = area * 111 * 111;
        calculatedArea=areaSqKm

        
        
        const defaultPriceInfo = {
          area_sqkm: calculatedArea,  // Use calculated area instead of 0
          imagery_cost_per_unit: 0.0,
          processing_cost_per_unit: 0.0,
          imagery_cost: 0.0,
          processing_cost: 0.0,
          total_cost: 0.0
        };
        
        setPriceInfo({
          isLoading: false,
          data: defaultPriceInfo,
          // error: error.message
        });
        // console.log(computedCosts)
      } catch (error) {
        let calculatedArea = 0.0;
        if (drawnCoordinates && drawnCoordinates.length > 1) {
            var polygon_turf = turf.polygon([
                drawnCoordinates
              ]);
              
            var area_turf = turf.area(polygon_turf);
            calculatedArea=area_turf/1000000
            console.log(JSON.stringify(drawnCoordinates))

        }
        
        const defaultPriceInfo = {
          area_sqkm: calculatedArea,  // Use calculated area instead of 0
          imagery_cost_per_unit: 0.0,
          processing_cost_per_unit: 0.0,
          imagery_cost: 0.0,
          processing_cost: 0.0,
          total_cost: 0.0
        };
        
        setPriceInfo({
          isLoading: false,
          data: defaultPriceInfo,
          error: error.message
        });
      }
    };

    fetchPricing();
  }, [drawnCoordinates, selectedImages, processingDetails]);

  const handleConfirmOrder = async () => {
    try {
      // Use price info from API if available, otherwise fallback to calculateCosts
      const costs = priceInfo.data || calculateCosts();
      // console.log("costs",costs)
      
      // Properly structure the data being sent
      const updatedOrderData = {
        status: 'Accepted',
        order_type: orderType,
        project_name: orderName,
        estimated_delivery_date: estimatedDeliveryDate.toISOString(), // Add the datetime to the order data
        processing_details: {
          level: processingDetails.level,
          radiometric_processing: processingDetails.radiometric_processing,
          geometric_processing: processingDetails.geometric_processing,
          delivery_details: processingDetails.delivery_details
        },
        selected_images: orderType === 'archival' ? selectedImages : [{"satellite": taskDetails.constellationName,
                                                                      "cloud_cover": taskDetails.cloudCover, 
                                                                      "resolution":taskDetails.resolution, 
                                                                      "off_nadir_angle": taskDetails.offNadirAngle, 
                                                                      "coverage_percentage": taskDetails.aoiCoverage,
                                                                      "area":taskDetails.aoiArea || (costs?.area_sqkm || 0),
                                                                      "strip_coordinates":taskDetails.coordinates}],
        aoi_coordinates: drawnCoordinates || [],
        cost_details: {
          imagery_cost_per_unit: costs?.imagery_cost_per_unit ?? 0,
          processing_cost_per_unit: costs?.processing_cost_per_unit ?? 0,
          area_sqkm: costs?.area_sqkm ?? 0,
          total_cost: costs?.total_cost ?? 0
        }
      };
  
      console.log('Sending order data:', updatedOrderData); // Debug log
      
      await saveDraftOrder(updatedOrderData, orderId);
      history.push('/orders');
    } catch (error) {
      console.error('Error confirming order:', error);
      alert('Error confirming order: ' + (error.message || 'Unknown error'));
    }
  };

  // Fallback method for calculating costs if API is not available
  const calculateCosts = () => {
    if (!orderData?.selected_images || !orderData?.aoi_coordinates) return null;

    const imageryUnitCost = 12;
    const processingUnitCost = 5;
    const area = 150;

    const imageryCost = imageryUnitCost * area;
    const processingCost = processingUnitCost * area;

    return {
      imagery_cost_per_unit: imageryUnitCost,
      processing_cost_per_unit: processingUnitCost,
      area_sqkm: area,
      imagery_cost: imageryCost,
      processing_cost: processingCost,
      total_cost: imageryCost + processingCost
    };
  };

  if (isLoading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  // Get the price data
  const costs = priceInfo.data || calculateCosts();

  // Function to format the delivery date for display
  const formatDeliveryDate = (date) => {
    if (!date) return '';
    
    return date.toLocaleString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  // Function to format currency
  const formatCurrency = (value) => parseFloat(value ?? 0).toFixed(1);


  // Function to determine which table to render based on order type
  const renderDataTable = () => {
    if (orderType === 'tasking') {
      return (
        <Box key="tasking-products" sx={{ mb: 4 }}>
        <Box sx={{ 
          width: '100%',
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2
        }}>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center',
            gap: 1 
          }}>
            <Typography sx={{ 
              fontSize: '16px',
              fontWeight: 500,
              color: '#333'
            }}>
              {`${selectedImages?.length || 1} tasking request${selectedImages?.length > 1 ? 's' : ''} in the cart`}
            </Typography>
            <Button 
              sx={{ 
                textTransform: 'none',
                fontSize: '14px',
                color: '#4287f5',
                fontWeight: 400
              }}
            >
              Tasking Information
            </Button>
          </Box>
        </Box>
    
        {/* Table Header */}
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
          backgroundColor: '#f5f5f5',
          py: 1.5,
          borderRadius: '4px 4px 0 0',
          borderBottom: '1px solid #e0e0e0'
        }}>
          {['CONSTELLATION', 'RESOLUTION (m)', 'CLOUD COVER %', 'OFF NADIR ANGLE (DEG)', 
            'AOI AREA (sqkm)', 'AOI COVERAGE %', 'ESTIMATED TIME TO CAPTURE'].map((header) => (
            <Typography key={header} sx={{ 
              fontSize: '12px', 
              fontWeight: 500, 
              color: '#555', 
              px: 1, 
              textAlign: 'center'
            }}>
              {header}
            </Typography>
          ))}
        </Box>
    
        {/* Single Table Row */}
        <Box 
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
            py: 1.5,
            borderBottom: '1px solid #e0e0e0',
            alignItems: 'center',
            '& > *': {
              px: 1,
              textAlign: 'center',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }
          }}
        >
          <Typography sx={{ fontSize: '14px', color: '#333' }}>
            {taskDetails.constellationName || 'N/A'}
          </Typography>
          <Typography sx={{ fontSize: '14px', color: '#333' }}>
            {taskDetails.resolution || 'N/A'}
          </Typography>
          <Typography sx={{ fontSize: '14px', color: '#333' }}>
            {taskDetails.cloudCover || 'N/A'}
          </Typography>
          <Typography sx={{ fontSize: '14px', color: '#333' }}>
            {taskDetails.offNadirAngle }
          </Typography>
          <Typography sx={{ fontSize: '14px', color: '#333' }}>
            {costs?.area_sqkm ? parseFloat(costs.area_sqkm).toFixed(2) : parseFloat(taskDetails.aoiArea).toFixed(2) || '0'}
          </Typography>
          <Typography sx={{ fontSize: '14px', color: '#333' }}>
            {}
          </Typography>
          <Typography sx={{ fontSize: '14px', color: '#333' }}>
            {taskDetails.estimatedTimeToCapture || 'N/A'}
          </Typography>
        </Box>
      </Box>
    );
    } else {
      // Original catalog products table
      console.log(selectedImages)
      
      const groupImagesByConstellation = (selectedImages) => {
        return selectedImages.reduce((acc, image) => {
          const constellation = image.satellite || 'Unknown';
          if (!acc[constellation]) {
            acc[constellation] = [];
          }
          acc[constellation].push(image);
          return acc;
        }, {});
      };

      return Object.entries(groupImagesByConstellation(selectedImages || [])).map(([constellation, images]) => (
        <Box key={constellation} sx={{ mb: 4 }}>
          <Box sx={{ 
            width: '100%',
            display: 'flex', 
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2
          }}>
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center',
              gap: 1 
            }}>
              <Typography sx={{ 
                fontSize: '16px',
                fontWeight: 500,
                color: '#333'
              }}>
                {`${images.length} data product${images.length > 1 ? 's' : ''} in the cart for ${constellation}`}
              </Typography>
              <Button 
                sx={{ 
                  textTransform: 'none',
                  fontSize: '14px',
                  color: '#4287f5',
                  fontWeight: 400
                }}
              >
                Processing Information
              </Button>
            </Box>
          </Box>

          {/* Table Header */}
          <Box sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(9, minmax(0, 1fr))',
            backgroundColor: '#f5f5f5',
            py: 1.5,
            borderRadius: '4px 4px 0 0',
            borderBottom: '1px solid #e0e0e0'
          }}>
            {['DATA PRODUCT', 'CONSTELLATION', 'DATE OF CAPTURE', 'CLOUD COVER %', 'RESOLUTION (m)', 
              'OFF NADIR ANGLE (DEG)', 'AOI COVERAGE %', 'AREA (km²)', 'ACTION'].map((header) => (
              <Typography key={header} sx={{ 
                fontSize: '12px', 
                fontWeight: 500, 
                color: '#555', 
                px: 1, 
                textAlign: 'center',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>
                {header}
              </Typography>
            ))}
          </Box>

          {/* Table Rows */}
          {images.map((image) => (
            <Box 
              key={image.id}
              sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(9, minmax(0, 1fr))',
                py: 1.5,
                borderBottom: '1px solid #e0e0e0',
                alignItems: 'center',
                '& > *': {
                  px: 1,
                  textAlign: 'center',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <img 
                  src={image.previewUrl || "/api/placeholder/80/60"}
                  alt={`${constellation} image`}
                  style={{ 
                    width: '60px', 
                    height: '60px',
                    objectFit: 'cover',
                    borderRadius: '4px'
                  }}
                />
              </Box>
              <Typography sx={{ fontSize: '14px', color: '#333' }}>{constellation}</Typography>
              <Typography sx={{ fontSize: '14px', color: '#333' }}>{image.date}</Typography>
              <Typography sx={{ fontSize: '14px', color: '#333' }}>{image.cloud_cover} %</Typography>
              <Typography sx={{ fontSize: '14px', color: '#333' }}>{image.resolution}</Typography>
              <Typography sx={{ fontSize: '14px', color: '#333' }}>{image.off_nadir_angle} °</Typography>
              <Typography sx={{ fontSize: '14px', color: '#333' }}>{`${parseFloat(image.coveragePercentage)?.toFixed(2) || 0}`} %</Typography>
              <Typography sx={{ fontSize: '14px', color: '#333' }}>{costs?.area_sqkm ? parseFloat(costs.area_sqkm).toFixed(2) : ''}</Typography>
              <Box>
                <Button 
                  sx={{ 
                    textTransform: 'none',
                    fontSize: '14px',
                    color: '#4287f5',
                    p: 0,
                    minWidth: 'auto',
                    mr: 1
                  }}
                >
                  View
                </Button>
                |
                <Button 
                  sx={{ 
                    textTransform: 'none',
                    fontSize: '14px',
                    color: '#4287f5',
                    p: 0,
                    minWidth: 'auto',
                    ml: 1
                  }}
                >
                  Remove
                </Button>
              </Box>
            </Box>
          ))}
        </Box>
      ));
    }
  };

  return (
    <Box sx={{ 
      position: 'fixed',
      top: 48,
      left: 0,
      right: 0,
      bottom: 0,
      overflow: 'auto', 
      px: 2, 
    }}>
      {/* Combined Header: Back Button, Status Bar and Save Draft */}
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'flex-start', 
        alignItems: 'center',
        bgcolor: 'white',
        borderRadius: '8px',
        px: 2,
        gap: 2,
        mt: 1
      }}>
        <Button
          startIcon={<ChevronLeft />}
          sx={{
            color: '#4287f5',
            textTransform: 'none',
            fontSize: '14px',
            fontWeight: 500,
            minWidth: 'auto',
            whiteSpace: 'nowrap',
            '&:hover': {
              bgcolor: 'transparent',
              opacity: 0.8
            }
          }}
          onClick={() => history.goBack()}
        >
          Edit Order
        </Button>
        <Button 
          endIcon={<MapIcon />}
          sx={{
            color: '#4287f5',
            textTransform: 'none',
            fontSize: '14px',
            fontWeight: 500,
            minWidth: 'auto',
            whiteSpace: 'nowrap',
            '&:hover': {
              bgcolor: 'transparent',
              opacity: 0.8
            },
            ml: 100
          }}
        >
          View selected region
        </Button>
      </Box>

      {/* Main Content and Request Details */}
      <Box sx={{ 
        display: 'flex',
        gap: 0,
        mt: 0, 
        position: 'relative',
        mt: -1.5
      }}>
        {/* Left Side - Data Tables */}
        <Box sx={{ 
          flex: 1,
          width: '80%',
          bgcolor: 'transparent',
          borderRadius: '8px',
          p: 1,
          overflow: 'auto'
        }}>
          {renderDataTable()}
        </Box>

        {/* Right Side - Request Details */}
        <Box sx={{ 
          flex: '0 0 20%', 
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          backgroundColor: '#f2f0f0',
          overflow: 'auto',
          px: 2,
          py: 2,
          pb: 2,
          mt: -3
        }}>
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            mb: 2
          }}>
            <Typography sx={{ 
              fontSize: '18px',
              fontWeight: 500,
              color: '#000'
            }}>
              Order Details
            </Typography>
            <Button
              variant="outlined"
              disabled={userRole && userRole.toLowerCase() === 'hackathon'}
              sx={{
                color: (userRole && userRole.toLowerCase() === 'hackathon') ? '#999' : '#4287f5',
                borderColor: (userRole && userRole.toLowerCase() === 'hackathon') ? '#999' : '#4287f5',
                textTransform: 'none',
                fontSize: '14px',
                fontWeight: 500,
                whiteSpace: 'nowrap',
                opacity: (userRole && userRole.toLowerCase() === 'hackathon') ? 0.5 : 1,
                '&:hover': {
                  borderColor: (userRole && userRole.toLowerCase() === 'hackathon') ? '#999' : '#3276e3',
                  bgcolor: (userRole && userRole.toLowerCase() === 'hackathon') ? 'transparent' : 'rgba(66, 135, 245, 0.04)'
                }
              }}
            >
              Save Draft
            </Button>
          </Box>

          {/* Rest of the Request Details content remains the same */}
          <Box>
            {/* Order Name */}
            <Box sx={{ mb: 2 }}>
              <Typography sx={{ 
                color: '#555',
                fontSize: '14px',
                mb: 1
              }}>
                Order Name
              </Typography>
              <TextField
                fullWidth
                value={orderName}
                onChange={(e) => setOrderName(e.target.value)}
                placeholder="Enter order name"
                variant="outlined"
                sx={{
                  mb: 0.5,
                  '& .MuiOutlinedInput-root': {
                    bgcolor: 'white'
                  }
                }}
              />
              <Box>
                <Button 
                  component="a" 
                  sx={{ 
                    p: 0,
                    color: '#4287f5',
                    textTransform: 'none',
                    fontSize: '14px',
                    minWidth: 'auto',
                    '&:hover': {
                      bgcolor: 'transparent',
                      textDecoration: 'underline'
                    }
                  }}
                >
                  View project details
                </Button>
              </Box>
            </Box>

            {/* Order ID */}
            <Box sx={{ mb: 2 }}>
              <Typography sx={{ color: '#555', fontSize: '14px', mb: 1 }}>
                Order ID
              </Typography>
              <TextField
                fullWidth
                value={orderId}
                disabled
                variant="outlined"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    bgcolor: '#e6e6e6'
                  }
                }}
              />
            </Box>

            {/* Estimated Delivery Date */}
            <Box sx={{ mb: 2 }}>
              <Typography sx={{ 
                color: '#555',
                fontSize: '14px',
                mb: 1
              }}>
                Estimated Delivery Date
              </Typography>
              <TextField
                fullWidth
                value={formatDeliveryDate(estimatedDeliveryDate)}
                disabled
                variant="outlined"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    bgcolor: '#e6e6e6'
                  }
                }}
              />
            </Box>
            {Object.keys(taskDetails).length < 0 && (
            <TextField
                fullWidth
                value={formatDeliveryDate(estimatedDeliveryDate)}
                
                disabled
                variant="outlined"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    bgcolor: '#e6e6e6'
                  }
                }}
              />
            )}
            
              

            {/* Order Description */}
            <Box sx={{ mb: 2 }}>
              <Typography sx={{ 
                color: '#555',
                fontSize: '14px',
                mb: 1
              }}>
                Order Description
              </Typography>
              <TextField
                fullWidth
                placeholder="Type here....."
                multiline
                rows={8}
                variant="outlined"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    bgcolor: 'white'
                  }
                }}
              />
              
            </Box>
          </Box>

          {/* Summary Panel */}
          <Box sx={{
            bgcolor: '#f9f9f9',
            borderRadius: '8px',
            p: 3
          }}>
            <Typography sx={{ 
              fontSize: '18px',
              fontWeight: 500,
              color: '#000',
              mb: 3
            }}>
              Summary
            </Typography>

            {/* Display loading state if pricing info is loading */}
            {priceInfo.isLoading ? (
              <Typography sx={{ fontSize: '14px', color: '#666', fontStyle: 'italic' }}>
                Calculating pricing...
              </Typography>
            ) : priceInfo.error ? (
              <Typography sx={{ fontSize: '14px', color: '#f44336', fontStyle: 'italic' }}>
                Error calculating price: {priceInfo.error}
              </Typography>
            ) : (
              <>
                {/* Imagery Costs */}
                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  mb: 2
                }}>
                  <Typography sx={{ fontSize: '14px', color: '#333' }}>Imagery per unit cost</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography sx={{ fontSize: '14px', color: '#333', mr: 0.5 }}>
                    {formatCurrency(costs?.imagery_cost_per_unit)}

                    </Typography>
                    <TollIcon sx={{ fontSize: 16, color: '#333' }} />
                  </Box>
                </Box>

                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  mb: 2
                }}>
                  <Typography sx={{ fontSize: '14px', color: '#333' }}>Area</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography sx={{ fontSize: '14px', color: '#333', mr: 0.5 }}>
                      {costs?.area_sqkm ? formatCurrency(costs.area_sqkm) : '-'} sqkm
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  mb: 2
                }}>
                  <Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#4287f5' }}>Subtotal</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#4287f5', mr: 0.5 }}>
                      {formatCurrency(costs?.imagery_cost)}
                    </Typography>
                    <TollIcon sx={{ fontWeight: 600, fontSize: 16, color: '#4287f5' }} />
                  </Box>
                </Box>

                <Divider sx={{ my: 2 }} />

                {/* Processing Costs */}
                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  mb: 2
                }}>
                  <Typography sx={{ fontSize: '14px', color: '#333' }}>Processing per unit cost</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography sx={{ fontSize: '14px', color: '#333', mr: 0.5 }}>
                      {formatCurrency(costs?.processing_cost_per_unit)}
                    </Typography>
                    <TollIcon sx={{ fontSize: 16, color: '#333' }} />
                  </Box>
                </Box>

                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  mb: 2
                }}>
                  <Typography sx={{ fontSize: '14px', color: '#333' }}>Area</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography sx={{ fontSize: '14px', color: '#333', mr: 0.5 }}>
                      {costs?.area_sqkm ? formatCurrency(costs.area_sqkm) : '0'} sqkm
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  mb: 2
                }}>
                  <Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#4287f5' }}>Subtotal</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#4287f5', mr: 0.5 }}>
                      {formatCurrency(costs?.processing_cost)}
                    </Typography>
                    <TollIcon sx={{ fontWeight: 600, fontSize: 16, color: '#4287f5' }} />
                  </Box>
                </Box>

                <Divider sx={{ my: 2 }} />

                {/* Total */}
                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  mb: 2
                }}>
                  <Typography sx={{ fontSize: '15px', fontWeight: 600, color: '#4287f5' }}>Total</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography sx={{ fontSize: '15px', fontWeight: 600, color: '#4287f5', mr: 0.5 }}>
                      {formatCurrency(costs?.total_cost)}
                    </Typography>
                    <TollIcon sx={{ fontWeight: 600, fontSize: 16, color: '#4287f5' }} />
                  </Box>
                </Box>
              </>
            )}

            <Button 
              fullWidth
              variant="contained" 
              sx={{ 
                bgcolor: '#4287f5',
                textTransform: 'none',
                fontSize: '16px',
                fontWeight: 500,
                py: 1.5,
                mt: 2,
                '&:hover': {
                  bgcolor: '#3276e3'
                }
              }}
              onClick={handleConfirmOrder}
            >
              Confirm Order
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CheckoutPage;